import { service } from '../../../../helpers/http'

// Histórico paginado de execuções do período atual (mais recentes primeiro).
export const ActionGetRuns = ({ dispatch }, payload) => {
    return service({
        module: 'domainCatalogJoin',
        action: 'getRuns',
        params: { page: payload.page, per_page: payload.per_page }
    })
}

export const ActionGetRun = ({ dispatch }, payload) => {
    return service({
        module: 'domainCatalogJoin',
        action: 'getRun',
        payload: { id: payload.id }
    })
}

// Falhas por item de uma execução. id vai na URL, page na query.
export const ActionGetRunErrors = ({ dispatch }, payload) => {
    return service({
        module: 'domainCatalogJoin',
        action: 'getRunErrors',
        params: { id: payload.id, page: payload.page }
    })
}

// params:{} (truthy) força o corpo no POST.
export const ActionStartRun = ({ dispatch }) => {
    return service({
        module: 'domainCatalogJoin',
        action: 'startRun',
        params: {}
    })
}

// Cancela a execução e remove da fila só os jobs de item dela. id vai na URL; params:{id} também força o POST.
export const ActionCancelRun = ({ dispatch }, payload) => {
    return service({
        module: 'domainCatalogJoin',
        action: 'cancelRun',
        params: { id: payload.id }
    })
}
